import { connect } from 'react-redux';
import { Header } from 'components/HeaderNew';
import NotificationActions from 'store/notifications/actions';
import ClubActions from 'store/clubs/actions';
import AuthActions from 'store/auth/actions';

const mapStateToProps = state => {
  return {
    notifications: state.notifications.data,
    messagesHistory: state.messages.messagesHistory,
    profileDetails: state?.auth?.profile,
  };
};
const mapDispatchToProps = {
  handleReadOnOpenPopUp: NotificationActions.Creators.markAsReadAllNotifications,
  loadClubs: ClubActions.Creators.loadClubsRequest,
  loadProfile: AuthActions.Creators.loadProfileRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
